export interface Category {
  id: string
  name: string
  isActive: boolean
  thumbImageUrl: string
  imageUrl: string
}

export const categoryConverter: firebase.firestore.FirestoreDataConverter<Category> = {
  toFirestore: (category) => {
    return {
      name: category.name,
      isActive: category.isActive,
      thumbImageUrl: category.thumbImageUrl,
      imageUrl: category.imageUrl
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      name: data.name,
      isActive: data.isActive,
      thumbImageUrl: data.thumbImageUrl,
      imageUrl: data.imageUrl
    }
  }
}
